export enum VaultsMethods {
  Stake = 'stake',
  Unstake = 'unstake',
  Claim = 'claim',
  StakeAnyToken = 'stakeAnyToken',
  StakeETH = 'stakeETH'
}
